export default __webpack_public_path__ + "static/media/logo-horizontal.2a761ac8.svg";